import { DefaultLogic } from '../default';

export class WeightlossLogic extends DefaultLogic {
    getColors() {
        return {
            primary: '#89d4ef',
            secondary: '#ec5968',
            background: '#FFFFFF',
            accent: '#000f80',
        };
    }
}
